import styled from "styled-components";

export const RowFlex = styled.div`
  display: flex;
  gap: 20px;
  width: 100%;
  flex-wrap: wrap;
  margin-bottom: 20px;
  .card {
    background-color: white;
    min-width: 284px;
    width: 300px;
    max-width: 350px;
    border-radius: 8px;
    max-height: 200px;
    height: 170px;
    min-height: 160px;
  }
`;

export const Add = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const FormWrapper = styled.div`
  padding: 0px 30px 30px 30px;
  .date {
    display: grid;
    grid-template-columns: 6fr 6fr;
    gap: 10px;
  }
  .mtop {
    margin-top: 10px;
  }
  .area {
    display: flex;
    align-items: end;
    gap: 10px;
    width: 100%;
  }
  .textArea {
    width: 100%;
  }
  .del {
    color: red;
    border: none;
    outline: none;
    background: none;
    padding-bottom: 15px;
    font-size: 20px;
    cursor: pointer;
  }
  .send {
    margin-top: 10px;
  }
`;
export const WrapModal = styled.div`
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  width: 100%;
  margin-bottom: 10px;
`;
export const AddButton = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  .add {
    background-color: #8490a5;
    border-radius: 50%;
    opacity: 20%;
    border: none;
    outline: none;
    display: flex;
    height: 24px;
    padding: 4px;
    justify-content: center;
    align-items: center;
    cursor: pointer;
  }
  .border {
    background-color: #8490a5;
    width: 100%;
    height: 2px;
    opacity: 20%;
  }
`;
export const ModalDesign = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 0px 20px;
  ul {
    padding: 0px 20px;
  }
  .title {
    font-family: Inter;
    font-size: 15px;
    font-weight: 700;
    line-height: 16.5px;
    color: #343c6a;
    padding-bottom: 10px;
  }
  .desc {
    color: #545e76;
    font-family: Inter;
    font-size: 15px;
    font-weight: 500;
    line-height: 16.5px;
    padding-bottom: 8px;
  }
`;
